<template>
    <el-dialog title="模拟器" :visible.sync="dialog.show" width="1500px" :close-on-click-modal="false"
        :before-close="recipeDialogCancel" :open="open">
        <div>
            <!-- 头部 -->
            <div id="head">
                头部
            </div>
            <!-- 工具栏 -->
            <div id="utils">
                工具栏
            </div>
            <!-- 循环页面 -->
            <div id="loop">
                循环页面
            </div>
            <!-- 技能页面 -->
            <div id="skill">
                技能页面
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>


export default {
    props: {

    },
    name: "Recipe",
    data() {
        return {
            // 配装器基础配置
            dialog: {
                show: false,

            }
        }
    },
    methods: {
        init() {
        },
        open() {
            // 配置所有的缓存
            this.init();
            console.log(this.$parent.sectImpl)
            // 打开对话框
            this.dialog.show = true;
        },
    },
    mounted() {
        this.init();
    }

}
</script>


<style lang="less" scoped>
.recipeLine {
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid;
    border-radius: 10px;
    display: flex;

    .recipeLineTitle {
        width: 100px;
        padding-right: 10px;
        font-size: 20px;
        font-weight: bold;
        color: rgb(211, 36, 36)
    }
}
</style>